import type { AsyncState } from '@essent/common';
import {
  createAsyncStateReducer,
  createInitialAsyncState,
} from '@essent/common';
import type { StoreProductData } from '@legacy/common-ui-models';
import {
  getStoreProductsActions,
  postStoreOrderActions,
} from '@innogy/feh/temporary-core-modules';
import type { Action, ActionReducerMap } from '@ngrx/store';
import { combineReducers } from '@ngrx/store';
import type { GetBoilerProductsResponseSchema } from '@integration/api-client/feh';
import { FehApiActions } from '@feh/shared-api';

export const storeApiKey = 'storeAPI';

export type GetStoreProductsState = AsyncState<{
  products: StoreProductData[];
}>;
export type PostStoreOrderState = AsyncState<void>;

export type GetBoilerProductsState =
  AsyncState<GetBoilerProductsResponseSchema>;

export interface StoreAPIState {
  getStoreProducts: GetStoreProductsState;
  postStoreOrder: PostStoreOrderState;
  getBoilerProducts: GetBoilerProductsState;
}

export const initialStoreAPIState: StoreAPIState = {
  getStoreProducts: createInitialAsyncState(),
  postStoreOrder: createInitialAsyncState(),
  getBoilerProducts: createInitialAsyncState(),
};

const _getStoreProductsReducer = createAsyncStateReducer(
  getStoreProductsActions
);

const _postStoreOrderReducer = createAsyncStateReducer(postStoreOrderActions);

const _getBoilerProductsReducer = createAsyncStateReducer(
  FehApiActions.getBoilerProducts
);

const _reducers: ActionReducerMap<StoreAPIState, Action> = {
  getStoreProducts: _getStoreProductsReducer,
  postStoreOrder: _postStoreOrderReducer,
  getBoilerProducts: _getBoilerProductsReducer,
};

const _combinedReducers = combineReducers(_reducers);
export const storeAPIReducer = (
  state: StoreAPIState = initialStoreAPIState,
  action: Action
): StoreAPIState => _combinedReducers(state, action);
